import React, { useState } from "react";
import { 
  Container, TextField, Typography, Button, Checkbox, FormControlLabel, 
  Grid 
} from "@mui/material";
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';



const RealEstateForm = () => {
  const [formData, setFormData] = useState({
    address: "",
    lotSize: "",
    squareFootage: "",
    yearBuilt: "",
    bedrooms: "",
    bathrooms: "",
    mortgageDetails: "",
    propertyTaxes: "",
    hoaFees: "",
    renovations: "",
    appliances: [],
    knownIssues: "",
    sellingTimeline: "",
    listingPrice: "",
    showingPreferences: "",
    neighborhoodPerks: "",
    utilityCosts: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      appliances: checked
        ? [...prevData.appliances, value]
        : prevData.appliances.filter((item) => item !== value),
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Submitted Data:", formData);
  };

  return (
    <Container maxWidth="md">
      <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
        <Typography component="h2" variant="h4" gutterBottom align="center">
          Create a New Listing in Rocket Offer
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <form onSubmit={handleSubmit}>
          <TextField fullWidth label="Address" name="address" value={formData.address} onChange={handleChange} margin="normal" required />
          
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField fullWidth label="Lot Size (sq ft)" name="lotSize" type="number" value={formData.lotSize} onChange={handleChange} margin="normal" />
            </Grid>
            <Grid item xs={6}>
              <TextField fullWidth label="Square Footage" name="squareFootage" type="number" value={formData.squareFootage} onChange={handleChange} margin="normal" />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={4}>
              <TextField fullWidth label="Year Built" name="yearBuilt" type="number" value={formData.yearBuilt} onChange={handleChange} margin="normal" />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth label="Bedrooms" name="bedrooms" type="number" value={formData.bedrooms} onChange={handleChange} margin="normal" />
            </Grid>
            <Grid item xs={4}>
              <TextField fullWidth label="Bathrooms" name="bathrooms" type="number" value={formData.bathrooms} onChange={handleChange} margin="normal" />
            </Grid>
          </Grid>
          
          <TextField fullWidth label="Mortgage Details" name="mortgageDetails" value={formData.mortgageDetails} onChange={handleChange} margin="normal" multiline rows={4} />

          <Typography variant="h6">Included Appliances</Typography>
          {['Refrigerator', 'Stove', 'Dishwasher', 'Microwave', 'Washer', 'Dryer', 'Freezer', 'Garbage Disposal'].map((appliance) => (
            <FormControlLabel
              key={appliance}
              control={<Checkbox value={appliance} onChange={handleCheckboxChange} checked={formData.appliances.includes(appliance)} />}
              label={appliance}
            />
          ))}
          
          <TextField fullWidth label="Known Issues" name="knownIssues" value={formData.knownIssues} onChange={handleChange} margin="normal" multiline rows={4} />

          <TextField fullWidth label="Target Closing Date" name="sellingTimeline" type="date" InputLabelProps={{ shrink: true }} value={formData.sellingTimeline} onChange={handleChange} margin="normal" />
          <TextField fullWidth label="Listing Price" name="listingPrice" type="number" value={formData.listingPrice} onChange={handleChange} margin="normal" />
          
          <TextField fullWidth label="Showing Preferences" name="showingPreferences" value={formData.showingPreferences} onChange={handleChange} margin="normal" multiline rows={4} />
          <TextField fullWidth label="Neighborhood Perks" name="neighborhoodPerks" value={formData.neighborhoodPerks} onChange={handleChange} margin="normal" multiline rows={4} />
          <TextField fullWidth label="Utility Costs" name="utilityCosts" value={formData.utilityCosts} onChange={handleChange} margin="normal" />
          
          <Button type="submit" variant="outlined" color="primary" fullWidth>
            Submit
          </Button>
        </form>
      </Paper>
    </Container>
  );
};

export default RealEstateForm;
